import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum'
import { ENV } from './common/core/domain/env';

@Injectable({
  providedIn: 'root'
})
export class DataDogService {

  init(env: string, connectUserId: string, businessUnit: string) {
    if (/*env === ENV.localhost ||*/ env === ENV.stag || env === ENV.prod) {
      datadogRum.init({
        applicationId: 'f3f4df53-1a61-4f4a-8f8e-749f80b67a2d',
        clientToken: 'pubdff36bb309c023390415cb33193593db',
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.eu',
        service: 'admin-user-access',
        env: env,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        // sessionReplaySampleRate: 20,
        // defaultPrivacyLevel: 'mask',
      });

      datadogRum.setUser({
        id: connectUserId,
        businessUnit: businessUnit
      });
    }
  }

  /**
   * Records a named action against the current RUM session.
   *
   * Silently discarded wherever `init` did not run (localhost and int), which is deliberate: the
   * caller should not have to know which environments report. Not literally a no-op - the RUM
   * SDK buffers pre-`init` calls (`preStartRum` -> `new BufferedObservable(BUFFER_LIMIT)`, with
   * `BUFFER_LIMIT = 500`) and drains them on `init`, so where `init` never comes they sit in
   * memory until the tab closes. Bounded and harmless, but worth stating accurately: "no-op"
   * would suggest the call is free to make in a loop, and it is not.
   *
   * `context` reaches Datadog, so it carries ids and counts and never names, emails or
   * anything else a person reads. The signed-in user's own id is already on the session from
   * `setUser` above; entity ids are the same class of data and are what makes an action
   * correlate with the audit trail on our side.
   */
  addAction(name: string, context?: Record<string, unknown>): void {
    datadogRum.addAction(name, context);
  }
}
